import { media } from '../../../utils/styles'
import styled from 'styled-components'
import { ClbIcon } from '@celebration/react'
import NxHeading from '../../heading/NxHeading'
import { NxText } from '../../text'

export const Container = styled.div`
  padding: var(--spacing-size-xl) var(--spacing-size-4xl);

  & > button {
    display: block;
    margin: var(--spacing-size-3xs) 0;
  }

  ${media.tablet`
    padding-left: var(--spacing-size-2xl);
    padding-right: var(--spacing-size-2xl);

    & > button {
      display: table;
      margin: var(--spacing-size-3xs) auto;
    }
  `}

  ${media.mobile`
    padding-left: var(--spacing-size-xl);
    padding-right: var(--spacing-size-xl);
  `}

  ${media.smallMobile`
    padding-left: var(--spacing-size-lg);
    padding-right: var(--spacing-size-lg);
  `}
`

export const Icon = styled(ClbIcon)`
  margin: 0;
  display: inline-block;

  ${media.tablet`
    margin: 0 auto var(--spacing-size-3xs);
    display: table;
  `}
`

export const Title = styled(NxHeading)`
  display: block;
  margin: var(--spacing-size-4xs) 0;
`

export const Description = styled(NxText)`
  display: block;
  margin: var(--spacing-size-4xs) 0;
`
